import type {Keyword} from '@/api/keywordApi';

export const FETCH_KEYWORD_DATA = 'redux/v1/keywordData/fetchKeywordData';

export type Status = 'idle' | 'loading' | 'successful' | 'failed';

export type Data = Keyword;

type StatusState = Record<string, Status>;

type DataState = Partial<Record<string, null | Data>>;

type ErrorsState = Partial<Record<string, null | typeof Error>>;

export type KeywordDataState = {
  status: StatusState;
  data: DataState;
  errors: ErrorsState;
};
